import React from 'react';
import { PurchaseOrderStatus } from '../../../../../types/PurchaseOrder.types';
import { PURCHASE_ORDER_STATUS_LABELS } from '../../../../../constants/purchases';

// El valor del estado es también la clase del badge: shared-modules.css tiene
// una regla .module-badge.<status> por cada uno de los seis estados.
export const PurchaseOrderStatusBadge = ({ status }: { status: PurchaseOrderStatus }) => (
  <span className={`module-badge ${status}`}>{PURCHASE_ORDER_STATUS_LABELS[status] || status}</span>
);
